import { HelmetDexteel } from "@dexteel/mesf-core";
import { ProductsManager } from "./components/ProductsManager";

export const ProductsPage = () => {
	return (
		<>
			<HelmetDexteel title="Products" />
			<ProductsManager />
		</>
	);
};
